<template>
  <v-card outlined>
    <v-card-title>
      {{ $t("auditor.minimalRequirementForm.resultForm.title") }}
    </v-card-title>

    <v-card-text>
      <AssistantResultForm :requirement="requirement" @addToResult="addToResult" />

      <v-form ref="form" v-model="valid">
        <v-checkbox
          v-model="formData.applicable"
          :label="$t('auditor.minimalRequirementForm.resultForm.result.applicable')"
          @change="save"
        ></v-checkbox>

        <v-radio-group v-model="formData.result" v-if="formData.applicable" mandatory @change="save">
          <v-radio :label="$t('auditor.minimalRequirementForm.resultForm.result.pass')" value="PASS"></v-radio>

          <v-radio :label="$t('auditor.minimalRequirementForm.resultForm.result.fail')" value="FAIL"></v-radio>
        </v-radio-group>

        <MarkdownEditor
          :label="$t('auditor.minimalRequirementForm.resultForm.description.label')"
          :rules="[(v) => !!v || $t('validation.required')]"
          v-model="formData.description"
          @change="save"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn color="primary" @click="save" :disabled="!valid" :loading="loading">
        {{ $t("auditor.minimalRequirementForm.resultForm.save") }}
      </v-btn>

      <v-spacer />

      <v-btn v-if="requirement.state === 'DONE'" color="secondary" @click="remove" :loading="loading">
        {{ $t("auditor.minimalRequirementForm.resultForm.remove") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { pick } from "ramda";
import UpdateMinimalRequirementResultMutation from "@/gql/mutations/UpdateMinimalRequirementResultMutation.gql";
import RemoveMinimalRequirementResultMutation from "@/gql/mutations/RemoveMinimalRequirementResultMutation.gql";
import AssistantResultForm from "@/components/Audit/Fund/AssistantResultForm.vue";
import MarkdownEditor from "@/components/Common/MarkdownEditor.vue";

export default {
  components: {
    AssistantResultForm,
    MarkdownEditor,
  },

  props: {
    requirement: {
      type: Object,
      required: true,
    },

    fund: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: null,
      valid: false,
      loading: false,
    };
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      await this.$apollo.mutate({
        mutation: UpdateMinimalRequirementResultMutation,
        variables: {
          id: this.requirement.id,
          input: this.formData,
        },
      });

      this.loading = false;
      this.$emit("save");
    },

    async remove() {
      this.loading = true;

      await this.$apollo.mutate({
        mutation: RemoveMinimalRequirementResultMutation,
        variables: {
          id: this.requirement.id,
        },
      });

      this.loading = false;
      this.$emit("remove");
    },

    addToResult(result) {
      this.formData.description = result;
      this.save();
    },
  },

  watch: {
    // update form data if data is unchanged
    // that way the form is updated if the data has not been altered/worked on
    // if the data has been changed, it will not be updated
    requirement(requirement, oldRequirement) {
      if (oldRequirement.result.result === this.formData.result) this.formData.result = requirement.result.result;

      if (oldRequirement.result.description === this.formData.description)
        this.formData.description = requirement.result.description;

      if (oldRequirement.result.applicable === this.formData.applicable)
        this.formData.applicable = requirement.result.applicable;
    },
  },

  created() {
    this.formData = pick(["result", "description", "applicable"], this.requirement.result);
  },
};
</script>
